export var getMerchantIbanData = function (merchantDetails) {
    var bankAccountValues = merchantDetails.bankAccount.filter(function (account) { return account.id; });
    return bankAccountValues[0].id;
};
